export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';
